import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useEffect, useMemo } from 'react';
import { RouteLevelContext, RouteLevelProvider } from './context.js';
import { useMatchingRoute } from './hooks.js';
export function Outlet() {
    var _a, _b, _c, _d;
    const { match: parent, subpath, params: upstreamParams, } = useContext(RouteLevelContext);
    const match = useMatchingRoute(subpath, (_a = parent === null || parent === void 0 ? void 0 : parent.route.children) !== null && _a !== void 0 ? _a : null);
    const Component = (_c = (_b = parent === null || parent === void 0 ? void 0 : parent.route) === null || _b === void 0 ? void 0 : _b.component) !== null && _c !== void 0 ? _c : null;
    useEffect(() => {
        var _a;
        if ((_a = match === null || match === void 0 ? void 0 : match.route) === null || _a === void 0 ? void 0 : _a.onVisited) {
            match.route.onVisited(match.params);
        }
    }, [match]);
    const params = useMemo(() => (Object.assign(Object.assign({}, upstreamParams), parent === null || parent === void 0 ? void 0 : parent.params)), [upstreamParams, parent === null || parent === void 0 ? void 0 : parent.params]);
    if (Component) {
        return (_jsx(RouteLevelProvider, Object.assign({ match: match, subpath: (_d = match === null || match === void 0 ? void 0 : match.path) !== null && _d !== void 0 ? _d : subpath, params: params }, { children: _jsx(Component, {}) })));
    }
    return null;
}
//# sourceMappingURL=Outlet.js.map